export const PROFILE_CHANGE_SUCCESS =
    'Success! Your changes are waiting for expert`s approval';
export const SUCCESSFUL_INVITE = 'Successfully invited';
export const SUCCESSFUL_UPLOAD = 'Successfully uploaded';
export const SUCCESSFUL_UPDATED = 'Successfully updated';
export const SUCCESSFUL_APPLIED = 'Successfully applied';
export const SUCCESSFUL_ARCHIVED = 'Successfully archived';
export const SUCCESSFUL_RESTORED = 'Successfully restored';
export const SUCCESSFUL_DELETED = 'Successfully deleted';
export const SUCCESSFUL_MERGED = 'Successfully merged';
export const SUCCESSFUL_CREATED = 'Successfully applied';

export const NO_USER_ID = 'User ID is missing.';
export const NO_COMPANY_ID = 'Company ID is missing.';

export const FAIL_MESSAGE = 'Something went wrong, please try again later';
export const SERVER_ERROR = 'A server error occurred, please try again later';
export const NETWORK_ERROR = 'Network error: Unable to reach server';
export const UNKNOWN_ERROR = 'An unknown error occurred';

export const DELETE_ACCOUNT_SUCCESS = 'Your account was successfully deleted.';
export const FAIL_INVITE = 'Unable to send invite. Please try again.';
export const NO_FILE_LOADED = 'No file was loaded. Please upload a file.';

export const FAILED_TO_ARCHIVE = 'Failed to archive the user.';
export const FAILED_TO_REMOVE_FROM_TEAM =
    'Failed to remove the user from the team.';
export const FAILED_TO_DELETE = 'Failed to delete the user.';

export const TIMESHEET_OVERLAPS =
    'Time range overlaps with another record on this date.';
